const lang = {
    ja: {
        address: '住所',
        apply: '適用する',
        audio: '音声',
        bigZone: 'ビッグゾーン',
        browse: '閲覧企業チェック完了',
        directToDetailProduct: 'ダイレクト選択',
        cancel: 'キャンセル',
        companyName: '社名',
        confirm: '確認ダイアログ',
        delete: '削除',
        edit: '編集',
        fullName: '氏名',
        image: '画像',
        industryType: '業種',
        logout: '出口',
        login: '入場',
        registerViewer: '入場申込',
        mailAddress: 'メールアドレス',
        noData: '該当するデータがありません。',
        organizeCompany: '出展参加者',
        organizer: '出展者',
        organizerBooth: '出展ブース',
        phoneNumber: '電話番号',
        price: '料金',
        price_ads: '広告料金',
        product: '商品',
        register: '登録',
        registerProduct: '出展登録作業',
        representative: '代表者',
        save: '保存する',
        saveCard: '送信する',
        search: '検索',
        smallZone: 'スモールゾーン',
        standardZone: 'スタンダードゾーン',
        timeRange: '時間帯',
        video: '動画',
        workplace: '勤務先',
        'workplace.company': '勤務先',
        zipCode: '郵便番号',
        zone: 'ゾーン',
        nameCompany: '出展企業',
        department: '部署',
        position: '役職',
        name: '氏名',
        lastName: '姓',
        firstName: '名',
        faxNumber: 'FAX 番号',
        emailPublic: '名刺用メールアドレス',
        emailNotifications: '通知先メールアドレス',
        exchangeBusinessCard: '名刺交換',
        csvProduct: '履歴CSVダウンロード',
        csvSeminar: 'セミナー受講履歴CSVダウンロード',
        csvLiveStream: 'ライブ配信申込み履歴CSVダウンロード',
        csvOrderProduct: '購入したグランドブース商品注文CSVダウンロード',
        switchViewMode: '{companyName}一覧・{productName}表示の切り替え',
        'apiErrors.auth': '認証エラーが発生しました。',
        'apiErrors.authExpired': '認証期限が切れました。',
        'apiErrors.default': '例外エラーが発生しました。',
        'apiErrors.network': 'ネットワークに接続できていません。',
        'apiErrors.permissionDenied': 'この権限がありません。',
        'apiSuccess.default': '適用しました。',
        'apiSuccess.createEvent': '催しを登録した後で、セミナー会議室・ブース情報を設定する必要がありますので、ご注意をください。',
        'apiSuccess.editEvent': '展示会ブース・セミナー開催の設定に更新がございましたら、セミナー会議室・ブース情報の設定を適切に更新する必要がありますので、ご注意をください。',
        'apiSuccess.create': '作成しました。',
        'apiSuccess.delete': '削除しました。',
        'apiSuccess.update': '更新しました。',
        'dialog.confirmDeleteTitle': '削除確認',
        'event.heldDate': '開催期間',
        'event.heldPlace': '開催場所',
        'event.heldTime': '開催時間',
        'validation.dateRange': '終了日には開始日以降の日付を指定してください。',
        'validation.dateTime': 'データは正しくありません。確認後、再度入力してください。',
        'validation.email': '正しいメール形式を入力してください。',
        'validation.fax': '半角数字で正しいFAX番号を入力してください。',
        'validation.fileFormat': 'ファイル形式は{formats}でなければなりません。',
        'validation.integer': '１以上整数を入力してください。',
        'validation.kanaChar': '全角カタカナで入力してください。',
        'validation.maxLength': '{maxLength}文字以内で入力してください（改行もカウントされます）。',
        'validation.maxSize': 'ファイルサイズは{maxSize}以下でなければなりません。',
        'validation.nonNegativeNumber': '１以上整数を入力してください。',
        'validation.number': '数字を入力してください。',
        'validation.phoneNumber': '半角数字で正しい電話番号を入力してください。',
        'validation.positiveNumber': '申し込みのいずれかを選ばなければなりません。',
        'validation.required': '必須です。入力してください。',
        'validation.requiredArray': 'このフィールド情報を入力してください。',
        'validation.requiredCheckbox': 'このボックスをチェックする必要があります。',
        'validation.requiredMultipleCheckboxes': 'ブース種別の一つ以上を選択してください。',
        'validation.requiredPattern': '全ての項目を入力してください。',
        'validation.sameValue': '再入力値が一致しません。',
        'validation.timeRange': '開始時間には終了時間より前の時間を指定してください。',
        'validation.totalTooSmall': '合計の値が画像と音声より大きくなければなりません。',
        'validation.url': '「http://」もしくは「https://」から始まるURLを入力してください。',
        'validation.limitValue': '広告搭載申込み件数は{minValue}~{maxValue}まで入力しないといけません。',
        'validation.bigWithSmall': '広告募集（1社当り限定）件数は広告総募集件数以下でなければなりません。',
        'zone.warning': 'このソーンに申し込んだ人がいますので、ご留意をください。',
        'zone.danger': 'このソーンに申し込んだ人がいますので、削除できません。',
        'validation.unique': 'ゾーン名が重複されました。',
        'dialog.confirm': '確認画面',
        'validation.urlOrIframe': '「http://」、「https://」で始まるURL、または「iframe」タグを含むURLを入力してください',

        // new cr 19/01/2021
        'browse.listOfCompany': '見たい企業リストを表示',

        status: '状況',
        is_paused: '停止中',
        is_deleted: '削除済み',
        deleted: '削除済み',
        normal: '通常',
        freeLogin: 'フリー入場',
        'validation.zone': 'ゾーンが選択されていません',

        nextProduct: '次の商品',
        prevProduct: '前の商品',
        backToList: '商品リストに戻る',

        free: '無料',
        noLimit: '制限なし',
        'validation.noSettingCost': '金額が設定されていません',
        'validate.creditExpired': 'クレジットカードの有効期限が切れています。',
        'validate.validateLimitNumber': '{minNumber}から{maxNumber}の数字を入力してください。',
        'validate.validateTextHalfSize': '半角数字で入力してください。',
        'validate.validateHexColor': 'hexカラーコードを入力してください。（ 例： #9aa0a6）',
        'validate.duplicateEmail': '登録されているメールアドレスが重複されました。',
        'validate.validateTextLatin': 'フォーマットは無効になっています。[a-zA-Z0-9]のみを許与します。',
        'validate.validatePassword': 'アルファベット大文字/小文字、数字のみで、入力可能な文字数は6~32文字です。',
        'validate.validateLatin': 'アルファベット文字・数字を入力してください',
        'validate.startTimeLivestream': 'ライブ配信開始時間は現在時間以降で指定してください。',
        'validate.sameTimeLivestream': 'ライブ配信で異なる日付を入力してください。',
        'validate.sameTimeRegisterLivestream': '選択した日付はライブ配信が登録されました。',
        'common.close': '閉じる',
        'common.errorInfo': 'エラーが発生しました入力された情報を確認してください',
        'common.no': 'しない',
        'common.yes': 'する',
        'common.noPermission': 'アクセスする権限がありません。',
        'common.required': '（必須）',
        'common.bankAccount': '銀行口座',
        'common.credit': 'クレジット',
        'common.exhibitApplication': '出展申込み',
        'common.hour': '時',
        'common.minute': '分',
        'common.second': '秒',
        'common.completeApplication': 'お申込みが完了しました。',
        'common.emailBillDetail': '請求内容を記載したメールをお送りしております。',
        'common.confirm': 'ご確認ください。',
        'common.sendMoney': '（送金いただけないと視聴できません）',
        'common.free': '無料',
        'common.date': '開催日',
        'common.seeMore': 'もっと見る',
        'common.bankTransfer': '銀行振込',
        'common.selectPayment': 'お支払方法を選択してください',
        'common.noPaymentMethod': 'イベントには支払い方法が設定されていないため、支払いできません。',
        'common.cardNumber': 'カード番号',
        'common.dateOfExpiry': '有効期限',
        'common.month': '月',
        'common.year': '年',
        'common.nominalName': '名義人名',
        'common.securityCode': 'セキュリティーコード',
        'common.people': '人',
        'common.noPreview': 'プレビュー画面でこの操作を実施できません。',
        'common.stop': '停止中',
        'common.title': 'タイトル',
        'common.performer': '出演者',
        'common.schedule': '日程',
        'common.livestreamRegister': '選択した日付は{namePage}が登録されました。',
        'common.country': '国・地域',
        'common.occupation': '職種',
        'common.category': '展示エリア',
        'common.employees': '従業員数',
        'common.admissionPurpose': '入場目的',
        'common.time': '月日',
        'common.time1': '時間 ',
        'common.conferenceRoom': '会議室',
        'common.action': 'アクション',
        'common.booth': 'ブース',
        'common.approve': '承認済み',
        'common.end': '終了',
        'common.yen': '円',
        'common.menu': 'メニュー',
        'validate.limitLengthZone': 'ゾーン名の長さは1より大きく20未満である必要があります。',
        'zone.industry': '{zone}、{industryType}',
        'datepicker.clear': 'クリア',
    },
    en: {
        address: 'Address',
        apply: 'Apply',
        audio: 'Sound',
        bigZone: 'Big zone',
        browse: 'Checking of companies viewed is completed.',
        directToDetailProduct: 'Direct selection',
        cancel: 'Cancel',
        companyName: 'Company name',
        confirm: 'Confirmation dialog',
        delete: 'Delete',
        edit: 'Edit',
        fullName: 'Name',
        image: 'Image',
        industryType: 'Industry sector',
        logout: 'Exit',
        login: '',
        registerViewer: '',
        mailAddress: 'Email address',
        noData: 'There is no matching data.',
        organizeCompany: 'Exhibition attendee',
        organizer: 'Exhibitor',
        organizerBooth: 'Exhibition booth',
        phoneNumber: 'Phone No.',
        price: 'Fee',
        price_ads: 'Ad rate',
        product: 'Product',
        register: 'Register',
        registerProduct: 'Register as an exhibitor',
        representative: 'Representative',
        save: 'Save',
        saveCard: 'Submit',
        search: 'Search',
        smallZone: 'Small zone',
        standardZone: 'Standard zone',
        timeRange: 'Time slot',
        video: 'Video',
        workplace: 'Workplace',
        'workplace.company': 'company',
        zipCode: 'Postal code',
        zone: 'Zone',
        nameCompany: 'Exhibitor (company name)',
        department: 'Department',
        position: 'Title',
        name: 'Name',
        lastName: 'Last name',
        firstName: 'First name',
        faxNumber: 'FAX No.',
        emailPublic: 'Email address for business card exchange',
        emailNotifications: 'Email address for notification',
        exchangeBusinessCard: 'Business card exchange',
        csvProduct: '',
        csvSeminar: '',
        csvLiveStream: '',
        csvOrderProduct: '',
        switchViewMode: 'Switching view between {companyName} and {productName}',
        'apiErrors.auth': 'Authentication error occurred.',
        'apiErrors.authExpired': 'Authentication expired.',
        'apiErrors.default': 'An unexpected error occurred.',
        'apiErrors.network': 'You are not connected to the network.',
        'apiErrors.permissionDenied': 'You are not authorized to do this.',
        'apiSuccess.default': 'Applied.',
        'apiSuccess.createEvent': 'Created.',
        'apiSuccess.editEvent': 'Deleted.',
        'apiSuccess.create': 'Updated.',
        'apiSuccess.delete': 'Deleted.',
        'apiSuccess.update': '',
        'dialog.confirmDeleteTitle': 'Deletion confirmed.',
        'event.heldDate': 'Event period',
        'event.heldPlace': 'Venue',
        'event.heldTime': 'Time',
        'validation.dateRange': 'End date should be after the start date.',
        'validation.dateTime': 'The data is not correct. Check the data and enter it correctly.',
        'validation.email': 'Please enter it in the correct email format.',
        'validation.fax': 'Please enter the correct FAX number in single-byte numerical letters.',
        'validation.fileFormat': 'File format must be {formats}.',
        'validation.integer': 'Please enter an integer of 1 or larger.',
        'validation.kanaChar': 'Please enter it in double-byte katakana.',
        'validation.maxLength': 'Please enter within {maxLength} letters (line breaks are also included in the count).',
        'validation.maxSize': 'The file size must be {maxSize} or smaller.',
        'validation.nonNegativeNumber': 'Please enter an integer of 1 or larger.',
        'validation.number': 'Please enter a number.',
        'validation.phoneNumber': 'Please enter correct phone number in single-byte numerical letters.',
        'validation.positiveNumber': 'Please select which to apply.',
        'validation.required': 'Required field. Please enter.',
        'validation.requiredArray': 'Please enter this field.',
        'validation.requiredCheckbox': 'Please check this box.',
        'validation.requiredMultipleCheckboxes': 'Please select one or more booth type.',
        'validation.requiredPattern': 'Please enter all fields.',
        'validation.sameValue': 'The reentered value doesn’t match with the first value.',
        'validation.timeRange': 'Please specify a start time earlier than an end time.',
        'validation.totalTooSmall': 'The total value must be greater than that of the image and sound.',
        'validation.url': 'Please enter URL starting with “http://” or “https://”.',
        'validation.limitValue': 'For the number of ads to apply, please enter the value ranging from {minValue} to {maxValue}.',
        'validation.bigWithSmall': 'The number of advertisers wanted ads (limitation per company) must be smaller than the total number of advertisers wanted ads.',
        'zone.warning': 'Please note that someone else already applied for this zone.',
        'zone.danger': 'This zone cannot be deleted because someone has applied for this zone.',
        'validation.unique': 'The zone name is already used.',
        'dialog.confirm': 'Confirmation screen',
        'validation.urlOrIframe': 'Please enter URL starting with “http://” or “https://”, or URL including “iframe” tag.',
        'browse.listOfCompany': 'View favorite company list',
        status: 'Status',
        is_paused: 'Pending',
        is_deleted: 'Deleted',
        deleted: 'Deleted',
        normal: 'Normal',
        freeLogin: '',
        'validation.zone': 'Zone is not selected.',
        nextProduct: 'Next product',
        prevProduct: 'Previous product',
        backToList: 'Back to the product list',
        free: 'Free',
        noLimit: 'No limitation',
        'validation.noSettingCost': '',
        'validate.creditExpired': 'Your credit card has expired.',
        'validate.validateLimitNumber': 'Please enter a number ranging from {minNumber} to {maxNumber}.',
        'validate.validateTextHalfSize': 'Please enter single-byte numerical letters.',
        'validate.validateHexColor': 'Please enter hex color code. (Example: #9aa0a6)',
        'validate.duplicateEmail': 'The same email address is already registered.',
        'validate.validateTextLatin': 'Invalid format. Only [a-zA-Z0-9] are accepted.',
        'validate.validatePassword': '',
        'validate.validateLatin': 'Please enter alphanumerical letters.',
        'validate.startTimeLivestream': 'Please specify the live streaming start time after the current time.',
        'validate.sameTimeLivestream': 'Please enter a different date for live streaming.',
        'validate.sameTimeRegisterLivestream': 'Another live streaming has been already registered for the selected date.',
        'common.close': 'Close',
        'common.errorInfo': 'An error occurred. Please check the data you entered.',
        'common.no': 'No',
        'common.yes': 'Yes',
        'common.noPermission': 'You are not authorized to access.',
        'common.required': ' (Mandatory)',
        'common.bankAccount': 'Bank account',
        'common.credit': 'Credit card',
        'common.exhibitApplication': 'Apply for Exhibition',
        'common.hour': ' hour',
        'common.minute': ' minute',
        'common.second': ' second',
        'common.completeApplication': 'Application completed.',
        'common.emailBillDetail': 'An email with billing information was sent.',
        'common.confirm': 'Please check that.',
        'common.sendMoney': '(The content becomes available after your payment.)',
        'common.free': 'Free',
        'common.date': 'Date',
        'common.seeMore': 'Learn more',
        'common.bankTransfer': 'Bank transfer',
        'common.selectPayment': 'Please select payment method.',
        'common.noPaymentMethod': 'You cannot pay because payment method is not set to the event.',
        'common.cardNumber': 'Credit card No.',
        'common.dateOfExpiry': 'Expiration date',
        'common.month': 'Month',
        'common.year': 'Year',
        'common.nominalName': 'Cardholder’s name',
        'common.securityCode': 'Security code',
        'common.people': 'Person(s)',
        'common.noPreview': 'This action is not allowed on preview screen.',
        'common.stop': 'Pending',
        'common.title': 'Title',
        'common.performer': 'Presenter',
        'common.schedule': 'Schedule',
        'common.livestreamRegister': 'A {namePage} has been registered for the selected date.',
        'common.country': 'Country/Region',
        'common.occupation': 'Occupation',
        'common.category': 'Category',
        'common.employees': 'Number of employees',
        'common.admissionPurpose': 'Purpose of entry',
        'common.time': 'Date',
        'common.time1': 'Time  ',
        'common.conferenceRoom': 'Conference room',
        'common.action': 'Action',
        'common.booth': 'Booth',
        'common.approve': 'Approved',
        'common.end': 'End',
        'common.yen': ' yen',
        'common.menu': 'menu',
        'validate.limitLength': '',
        'zone.industry': '{zone}, {industryType}',
        'datepicker.clear': 'Clear',
    },
};

export default lang;
